/* eslint-disable @typescript-eslint/no-var-requires */
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import PHRMobileNav from './components/PHRMobileNav';
import useGlobalMobileConfigs from '@/stores/globalConfigsMobile';
import useAuth from '@/stores/auth';

export default function PHRMobileScreen() {
  const getConfigs = useGlobalMobileConfigs((s) => s.getConfigs);
  const token = useAuth((s) => s.token);
  React.useEffect(() => {
    if (token) getConfigs();
  }, [token, getConfigs]);

  return (
    <div className="flex flex-1 flex-col w-full h-[100vh] overflow-hidden">
      <PHRMobileNav />
      <Outlet />
    </div>
  );
}
